import { useState, useRef, useEffect } from 'react';

export default function AudioToggle() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    // Note: In a real implementation, you would use an actual audio file
    // For now, we'll just track the state
    audioRef.current = new Audio();
    audioRef.current.loop = true;
    audioRef.current.volume = 0.15;
    
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };
  }, []);

  const toggleAudio = () => {
    if (audioRef.current) {
      if (isMuted) {
        // In production, set the src to your audio file
        // audioRef.current.src = '/path/to/norse-ambient-music.mp3';
        audioRef.current.play().catch(() => {
          // Handle autoplay restrictions
          console.log('Audio playback requires user interaction');
        });
        setIsMuted(false);
        setIsPlaying(true);
      } else {
        audioRef.current.pause();
        setIsMuted(true);
        setIsPlaying(false);
      }
    }
  };

  return (
    <button
      onClick={toggleAudio}
      className="fixed top-8 right-8 z-50 w-14 h-14 rounded-full bg-black border-2 border-[#d4af37] flex items-center justify-center transition-all duration-300 hover:bg-[#d4af37] hover:scale-110 group cursor-pointer"
      aria-label="Toggle audio"
    >
      <i className={`${isMuted ? 'ri-volume-mute-line' : 'ri-volume-up-line'} text-2xl text-[#d4af37] group-hover:text-black transition-colors duration-300`}></i>
    </button>
  );
}
